import React from "react";
import { Box, FileUpload, Icon } from "@amzn/awsui-components-react";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Button from "@amzn/awsui-components-react/polaris/button";
import "./FileUploader.scss";

interface FileUploaderProps {
  file: File | undefined;
  handleFileChange: (files: File[]) => void;
  validateRedrive?: () => void;
  redriveOK: boolean;
  removeDuplicates?: () => void;
  loading: boolean;
  fileError?: string;
  expandedFileToken?: boolean;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  file,
  handleFileChange,
  validateRedrive,
  redriveOK,
  removeDuplicates,
  loading,
  fileError,
  expandedFileToken = false,
}) => {
  return (
    <SpaceBetween size="m">
      <SpaceBetween size="xs" direction="horizontal" alignItems="center">
        <Box variant="h2">New Redrive</Box>
      </SpaceBetween>

      <SpaceBetween
        size="xs"
        direction={expandedFileToken ? "vertical" : "horizontal"}
        alignItems={expandedFileToken ? undefined : "center"}
      >
        <div
          className={
            expandedFileToken ? "file-uploader__expanded-token" : undefined
          }
        >
          <FileUpload
            accept="text/csv"
            onChange={({ detail }) => {
              handleFileChange(detail.value);
            }}
            i18nStrings={{
              uploadButtonText: (e) => (e ? "Replace File" : "Upload File"),
              removeFileAriaLabel: (_index, fileName) => `Remove ${fileName}`,
              errorIconAriaLabel: "Error",
            }}
            value={file ? [file] : []}
            fileErrors={file ? [fileError || null] : []}
            fileTokenAlignment={expandedFileToken ? "vertical" : "horizontal"}
            showFileSize={expandedFileToken}
            showFileLastModified={expandedFileToken}
            constraintText={
              expandedFileToken ? "CSV file with a 'dlq_pk' header." : undefined
            }
            multiple={false}
          />
        </div>
        {redriveOK && file && (
          <SpaceBetween size="xs" direction="horizontal" alignItems="center">
            <Icon name="status-positive" variant="success" />
            <Box>Redrive Ready</Box>
          </SpaceBetween>
        )}
      </SpaceBetween>

      {(validateRedrive || (removeDuplicates && file)) && (
        <SpaceBetween size="xs" direction="horizontal" alignItems="center">
          {validateRedrive && (
            <Button onClick={validateRedrive} disabled={loading}>
              Validate Redrive
            </Button>
          )}
          {removeDuplicates && file && (
            <Button onClick={removeDuplicates}>Remove Duplicates</Button>
          )}
        </SpaceBetween>
      )}
    </SpaceBetween>
  );
};
